import { registerFigure } from "./base.js";
/**
 * Labelled layers, top to bottom. A cross-section without the artwork.
 *
 * Earth's crust down to its core, the atmosphere, the layers of a volcano, soil
 * horizons, ocean zones — a large share of "how is that thing built" questions
 * are answered by naming the layers in order, and order is the whole content.
 *
 * This is also the groundwork for the `label` shell the brief has been asking
 * for: once layers render, tapping one is a small addition.
 */
export const partsFigure = registerFigure({
    kind: "parts",
    summary: "Labelled layers, stacked top to bottom.",
    chooseWhen: "The idea is what something is made of, in order — layers of the Earth, " +
        "the atmosphere, a volcano in cross-section. The order must be real and " +
        "must run top to bottom, outermost first.",
    issues(figure) {
        const labels = figure.labels ?? [];
        if (labels.length < 2)
            return ["Layers need at least two labels to be a picture."];
        // The shared shape allows twelve so `contrast` can fill a grid. A ring or a
        // stack of twelve is unreadable, so this kind holds its own line.
        if (labels.length > 5)
            return ["More than 5 layers stops being a picture."];
        if (labels.some((l) => l.trim().length === 0))
            return ["A layer cannot be blank."];
        return [];
    },
    normalise(figure) {
        return {
            kind: "parts",
            caption: figure.caption,
            labels: (figure.labels ?? []).map((l) => l.trim()),
        };
    },
    example: {
        kind: "parts",
        caption: "You live on the thinnest layer of all.",
        labels: ["Crust", "Mantle", "Outer core", "Inner core"],
    },
});
//# sourceMappingURL=parts.js.map